import React from 'react'
import { Link } from 'react-router-dom'

export default function LicensePickerIntro() {
  return (
    <div className='licensePicker--intro'>
      <h4>Universal License</h4>
      <p>For simplicity, our licenses are based on the company size. Desktop, website, broadcast, or app are all allowed with a single license. 
      If these fonts will be used for client work, the license should reflect their company size and be in their name, even if they won’t be installing the fonts. <Link 
          to='/licensing' target='_blank' rel='noreferrer'>Read&nbsp;more</Link></p>
      <p>
        Need help or something custom? Email us: <a href='mailto:hello@vectrotype.com'>hello@vectrotype.com</a>
      </p>
    </div>
  )
}
